import { checkRoundDecimals } from "./general"

export const initialCreateCompras = async () => {
    return {
        id: 0,
        numero: '000000',
        referencia: 'nueva compra',
        id_tipo_documento: null,
        id_forma_pago: null,
        id_moneda: null,
        simbolo: 'S/',
        separacion_miles: ',',
        separacion_decimales: '.',
        estado: null,
        fecha_emision: new Date(),
        id_proveedor: null,
        razon_social: null,
        validado: false,
        subtotal: 0,
        descuento: 0,
        monto_base: 0,
        impuesto_porcentaje: 0,
        impuesto_tipo_calculo: null,
        impuesto_nombre: null,
        total_impuesto: 0,
        total_compra: 0,
        observaciones: null,
        id_ppto: null,
        pagado: false,
        items: [],
        pagos: [],
        facturas: []
    }
}

export const initialAddTitles = async (newId) => {
    return {
        creado: false,
        id: newId,
        index: newId,
        nombre: '',
        cantidad: 0,
        dias: 0,
        precio_unitario: 0,
        subtotal: 0,
        id_servicio: 0,
        id_categoria: 0,
        id_titulo: null,
        tipo: 'title',
        items: [],
        id_ppto: null,
        id_item_ppto: null
    }
}

export const initialAddItems = async (newId, idTitulo) => {
    return {
        creado: false,
        id: newId,
        index: newId,
        nombre: '',
        cantidad: 0,
        dias: 0,
        precio_unitario: 0,
        subtotal: 0,
        id_servicio: 0,
        id_categoria: 0,
        id_titulo: idTitulo,
        tipo: 'item',
        id_ppto: null,
        id_item_ppto: null
    }
}

export const initialDuplicateItems = (item, newId) => {
    return {
        creado: false,
        id: newId,
        index: newId,
        nombre: item.nombre,
        cantidad: item.cantidad,
        dias: item.dias,
        precio_unitario: item.precio_unitario,
        subtotal: item.precio_unitario,
        id_servicio: item.id_servicio,
        id_categoria: item.id_categoria,
        id_titulo: item.id_titulo,
        tipo: item.tipo,
        items: item.items,
    }
}

export const initialCalculoTotales = async (detail = null, Newitems) => {

    let sumaSubtotal = 0;
    for (let i = 0; i < Newitems.length; i++) {
        const el = Newitems[i];
        if (Newitems[i].tipo === 'title') {
            const itemsByTitle = el.items;
            for (let x = 0; x < itemsByTitle.length; x++) {
                const element = itemsByTitle[x];
                sumaSubtotal += element.subtotal;
            }
        }
    }

    const factorImpuesto = (detail.impuesto_porcentaje ? (parseFloat(detail.impuesto_porcentaje) / 100) : 0);

    const subtotal = sumaSubtotal;
    const descuento = 0;
    const montoBase = subtotal - descuento;
    let totalImpuesto = montoBase * factorImpuesto;

    let totalCompra = 0;
    if (detail.impuesto_tipo_calculo === 'retencion') {
        totalCompra = montoBase - totalImpuesto;
    } else {
        totalCompra = montoBase + totalImpuesto;
    }

    totalImpuesto = parseFloat(totalImpuesto.toFixed(2));
    totalCompra = parseFloat(totalCompra.toFixed(2));

    const newTotales = {
        subtotal: subtotal,
        descuento: descuento,
        monto_base: montoBase,
        total_impuesto: totalImpuesto,
        total_compra: totalCompra
    }

    return newTotales
}

// nuevas funciones
export const setNewMontoInItems = async (newAmount, id, form) => {
    const newItems = form.items.map(it => {
        if (parseInt(it.id) === parseInt(id)) {
            return {
                ...it,
                precio_unitario: newAmount,
                subtotal: newAmount,
            }
        }
        return it
    })

    return newItems

}

export const getFinalTotals = async (dataForm, items) => {

    const { impuesto_porcentaje, impuesto_tipo_calculo } = dataForm

    let sumaSubtotal = 0
    for (let x = 0; x < items.length; x++) {
        sumaSubtotal += items[x].subtotal
    }

    const factorImpuesto = (impuesto_porcentaje ? (parseFloat(impuesto_porcentaje) / 100) : 0);

    const subtotal = sumaSubtotal
    const descuento = 0
    const montoBase = subtotal - descuento
    let totalImpuesto = montoBase * factorImpuesto

    let totalCompra = 0
    if (impuesto_tipo_calculo === 'retencion') {
        totalCompra = montoBase - totalImpuesto
    } else {
        totalCompra = montoBase + totalImpuesto
    }

    const totaPagado = 0
    const totalPorPagar = totalCompra

    return {
        sub_total: subtotal,
        descuento: descuento,
        monto_base: await checkRoundDecimals(montoBase, 2),
        total_impuesto: await checkRoundDecimals(totalImpuesto, 2),
        total_compra: await checkRoundDecimals(totalCompra, 2),
        total_pagado: await checkRoundDecimals(totaPagado, 2),
        total_por_pagar: await checkRoundDecimals(totalPorPagar, 2)
    }

}

export const getTotalToPay = async (dataForm) => {

    const { impuesto_porcentaje, impuesto_tipo_calculo, subtotal } = dataForm
    const newSubTotal = parseFloat(subtotal)

    const factorImpuesto = (impuesto_porcentaje ? (parseFloat(impuesto_porcentaje) / 100) : 0);
    let totalImpuesto = newSubTotal * factorImpuesto

    let totalToPay = 0
    if (impuesto_tipo_calculo === 'retencion') {
        totalToPay = newSubTotal - totalImpuesto
    } else {
        totalToPay = newSubTotal + totalImpuesto
    }

    return await checkRoundDecimals(totalToPay, 2)

}

export const getInfoTipoDoc = async (listaTiposDocumentos, tipoDocId) => {

    const infoFound = listaTiposDocumentos.find(d => d.id === parseFloat(tipoDocId))
    /* console.log('infoFound TOTOTO----', infoFound, tipoDocId) */

    if (infoFound) {
        return {
            impuesto_nombre: infoFound.impuestos[0].nombre_impuesto,
            impuesto_porcentaje: parseFloat(infoFound.impuestos[0].porcentaje_impuesto),
            impuesto_tipo_calculo: infoFound.impuestos[0].tipo_calculo,
        }
    }

    return {
        impuesto_nombre: null,
        impuesto_porcentaje: 0,
        impuesto_tipo_calculo: null
    }


}

export const setNewItemsValues = async (changedData) => {

    const { target, floatValue, items, itemId } = changedData

    const newItems = items.map(it => {

        /* if (parseInt(it.id) === parseInt(itemId)) { */

        if (it.id === itemId) {
            let newItem = it
            if (target === 'cantidad') newItem.cantidad = floatValue
            if (target === 'dias') newItem.dias = floatValue
            if (target === 'precio_unitario') newItem.precio_unitario = floatValue
            newItem.subtotal = newItem.cantidad * newItem.dias * newItem.precio_unitario

            return newItem

        }

        return it

    });

    return newItems

}

export const calcDetraccion = async (dataForm) => {
    const { porcentaje_detraccion, total_compra, valor_tipo_cambio, id_moneda, id_tipo_documento } = dataForm

    console.log({ total_compra, id_tipo_documento })

    const totalSolesCompra = parseFloat(total_compra || 0) * parseFloat(valor_tipo_cambio || 1)
    console.log({ totalSolesCompra })

    if (totalSolesCompra > 700 && parseInt(id_tipo_documento) === 1) {

        const porcentaje = (porcentaje_detraccion === 0 ? 12 : parseFloat(porcentaje_detraccion))
        let totalDetraccion = parseFloat(total_compra || 0) * ((porcentaje || 0) / 100)
        if (parseInt(id_moneda) === 4) {
            totalDetraccion = totalDetraccion * parseFloat(valor_tipo_cambio || 0)
        }

        return {
            aplica_detraccion: true,
            porcentaje_detraccion: porcentaje,
            total_detraccion: totalDetraccion
        }

    } else {

        return {
            aplica_detraccion: false,
            porcentaje_detraccion: 0,
            total_detraccion: 0
        }

    }

}